<template>
  <div class="maintenance">
    <div class="maintenance__card">
      <img class="maintenance__logo" alt="arztpool.de" src="/images/arztpool.svg?url" />
      <h1>Wir sind gleich wieder für Sie da.</h1>
      <p>Wir führen aktuell geplante Wartungsarbeiten durch. In wenigen Minuten ist die Plattform wieder verfügbar. Vielen Dank für Ihr Verständnis.</p>
      <p class="maintenance__hint">Sie können diese Seite in kurzer Zeit neu laden oder es später erneut versuchen.</p>
      <p class="maintenance__signature">— Ihr arztpool Team</p>
      <button class="maintenance__button" @click="reloadPage">Seite neu laden</button>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Maintenance',
    methods: {
      reloadPage(): void {
        window.location.reload();
      },
    },
  });
</script>

<style lang="scss" scoped>
  @import '@/scss/configs/colors';
  .maintenance {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgba(247, 248, 250, 0.9), #fff);
    padding: 24px;
  }

  .maintenance__card {
    width: 100%;
    max-width: 680px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
    padding: 32px;
    text-align: center;
  }

  .maintenance__logo {
    width: 220px;
    height: auto;
    margin: 12px auto 24px auto;
    display: block;
  }

  .maintenance h1 {
    font-size: 28px;
    line-height: 1.3;
    margin: 0 0 12px 0;
    color: $color-marine;
  }

  .maintenance p {
    font-size: 16px;
    color: #4a5568;
    margin: 0 0 8px 0;
  }

  .maintenance__hint {
    font-size: 14px;
    color: #718096;
    margin-bottom: 20px;
  }

  .maintenance__signature {
    font-size: 14px;
    color: #718096;
    margin: 0 0 20px 0;
  }

  .maintenance__button {
    background-color: $color-marine;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 10px 16px;
    font-weight: 600;
    cursor: pointer;
  }

  .maintenance__button:hover {
    background-color: darken($color-marine, 6%);
  }
</style>
